export default {
    categories:[],
}